import NotFoundPage from "./Home";
export default NotFoundPage;